import { fastDom } from '../dom';
class ElementManipulatorBase {
    cloneElement(element) {
        if (element instanceof HTMLElement) {
            return element.cloneNode(true);
        }
        else {
            throw new Error('element is not an HTMLElement');
        }
    }
    async remove(element) {
        if (element instanceof HTMLElement) {
            return fastDom.mutate(() => {
                element.remove();
            });
        }
        else {
            throw new Error('element is not an HTMLElement');
        }
    }
    createImage(src) {
        const img = new Image();
        img.src = src;
        return img;
    }
}
export function createFlatListManipulator() {
    return new FlatListManipulator();
}
class FlatListManipulator extends ElementManipulatorBase {
    async insert(element, container, position) {
        return this.insertElement(container, element, position);
    }
    async insertElement(sibling, elem, position) {
        if (sibling instanceof HTMLElement && elem instanceof HTMLElement) {
            return fastDom.mutate(() => {
                var _a, _b;
                if (position === 'before') {
                    (_a = sibling.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(elem, sibling);
                }
                else if (position === 'after') {
                    (_b = sibling.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(elem, sibling.nextElementSibling);
                }
            });
        }
        else if (elem instanceof HTMLElement) {
            throw new Error('sibling is not an HTMLElement');
        }
        else {
            throw new Error('elem is not an HTMLElement');
        }
    }
}
export function createHierarchicalListManipulator({ itemSelector, }) {
    return new HierarchicalListManipulator(itemSelector);
}
class HierarchicalListManipulator extends ElementManipulatorBase {
    constructor(itemSelector) {
        super();
        this.itemSelector = itemSelector;
    }
    async insert(element, container, position) {
        return this.insertElement(container, element, position);
    }
    async insertElement(sibling, elem, position) {
        if (sibling instanceof HTMLElement && elem instanceof HTMLElement) {
            return fastDom.mutate(() => {
                var _a, _b;
                if (position === 'inside') {
                    sibling.appendChild(elem);
                }
                else if (position === 'before') {
                    (_a = sibling.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(elem, sibling);
                }
                else if (position === 'after') {
                    (_b = sibling.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(elem, sibling.nextElementSibling);
                }
            });
        }
        else if (elem instanceof HTMLElement) {
            throw new Error('sibling is not an HTMLElement');
        }
        else {
            throw new Error('elem is not an HTMLElement');
        }
    }
}
